/**
 * The UTC offset of an IANA time zone at a given instant, in minutes
 * (positive east of Greenwich, e.g. 60 for Europe/Stockholm in winter)
 */
export default function getTimeZoneOffsetMinutes(
  date: Date,
  timeZone: string,
): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).formatToParts(date)

  const values = parts.reduce<Record<string, number>>((acc, part) => {
    if (part.type !== 'literal') {
      acc[part.type] = Number(part.value)
    }
    return acc
  }, {})

  const zonedAsUtc = Date.UTC(
    values.year,
    values.month - 1,
    values.day,
    values.hour,
    values.minute,
    values.second,
  )

  return Math.round((zonedAsUtc - date.getTime()) / 60000)
}
